import { Tooltip } from 'antd'
import cls from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Risk } from '@/schemas'

export const risks = [
  { value: '无', color: '#3AB427' },
  { value: '低', color: '#3AB427' },
  { value: '中', color: '#D26018' },
  { value: '高', color: '#D20B15' },
  { value: '极高', color: '#ef4444' },
]

export const risksEnum = risks.reduce(
  (acc, v) => ({
    ...acc,
    [v.value]: v.color,
  }),
  {}
)

export const getRiskColor = (risk: Risk | string | null | undefined) => {
  return risk && risk in risksEnum ? risksEnum[risk] : '#a3a3a3'
}

export const getRiskText: React.FC<{ risk: Risk | string | null | undefined; t: any }> = ({ risk, t }) => {
  return <span>{t(risk) || t('未填写')}</span>
}

interface RiskBarProps {
  risk: Risk | string | null | undefined
}

export const RiskBar: React.FC<RiskBarProps & React.HTMLAttributes<HTMLSpanElement>> = ({ risk, ...props }) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={getRiskText({ risk, t })}>
      <div
        {...props}
        className={cls('w-3px mr-12px flex-shrink-0', props.className)}
        style={{ ...props.style, background: getRiskColor(risk) }}
      />
    </Tooltip>
  )
}
